import axios from 'axios';
const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({ baseURL: API });

// Add auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sustek_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getIndustries = () => api.get('/api/industries');
export const getSites = (industry) => api.get('/api/sites', { params: { industry } });
export const getKpis = (industry, site) => api.get('/api/kpis', { params: { industry, site } });
export const getDashboardSummary = (industry) => api.get('/api/dashboard/summary', { params: { industry } });
export const getAlerts = (industry) => api.get('/api/alerts', { params: { industry } });
export const markAlertRead = (title) => api.put(`/api/alerts/${encodeURIComponent(title)}/read`);
export const getScenarios = (industry) => api.get('/api/scenarios', { params: { industry } });
export const getControlEvents = (industry, status) => api.get('/api/control-events', { params: { industry, status } });
export const runScenarioAnalysis = (payload) => api.post('/api/ai/scenario-analysis', payload);
export const runWhatIf = (payload) => api.post('/api/ai/what-if', payload);
export const getSiteDrilldown = (industry, site) => api.get('/api/site-drilldown', { params: { industry, site } });
export const saveScenario = (payload) => api.post('/api/scenarios/save', payload);
export const getScenarioHistory = (industry) => api.get('/api/scenarios/history', { params: { industry } });
export const deleteScenarioHistory = (id) => api.delete(`/api/scenarios/history/${id}`);
export const compareScenarios = (ids) => api.get('/api/scenarios/compare', { params: { ids: ids.join(',') } });
export const getThresholds = (industry) => api.get(`/api/thresholds/${encodeURIComponent(industry)}`);
export const updateThresholds = (industry, thresholds) => api.put(`/api/thresholds/${encodeURIComponent(industry)}`, { thresholds });
export const getHeatmap = () => api.get('/api/heatmap');
export const checkThresholds = () => api.post('/api/notifications/check');
export const getNotifications = (industry, unreadOnly) => api.get('/api/notifications', { params: { industry, unread_only: unreadOnly } });
export const markNotificationRead = (id) => api.put(`/api/notifications/${id}/read`);
export const markAllNotificationsRead = () => api.put('/api/notifications/read-all');
export const clearReadNotifications = () => api.delete('/api/notifications/clear');

// Reports Hub endpoints
export const getHubData = () => api.get('/api/reports-hub/data');
export const getHubComparison = () => api.get('/api/reports-hub/comparison');
export const getReportDetail = (reportId) => api.get(`/api/reports-hub/reports/${reportId}`);
export const hubSearch = (q) => api.get('/api/reports-hub/search', { params: { q } });
export const askTheHub = (question, filters) => api.post('/api/reports-hub/ask', { question, filters });
export const createHubAction = (payload) => api.post('/api/reports-hub/actions', payload);
export const updateHubActionStatus = (actionId, status) => api.put(`/api/reports-hub/actions/${actionId}/status`, { status });

// Admin Console endpoints
export const getAdminOverview = () => api.get('/api/admin/overview');
export const getAdminPipeline = () => api.get('/api/admin/pipeline');
export const getAdminTables = () => api.get('/api/admin/tables');
export const getAdminDictionary = () => api.get('/api/admin/dictionary');
export const getAdminLineage = () => api.get('/api/admin/lineage');
export const getAdminRelationships = () => api.get('/api/admin/relationships');
export const getAdminOnelake = () => api.get('/api/admin/onelake');

// CBAM Module endpoints
export const getCbamExecutive = () => api.get('/api/cbam/executive');
export const getCbamProducts = () => api.get('/api/cbam/products');
export const getCbamSuppliers = () => api.get('/api/cbam/suppliers');
export const getCbamShipments = () => api.get('/api/cbam/shipments');
export const getCbamDigitalTwin = () => api.get('/api/cbam/digital-twin');
export const getCbamAlerts = () => api.get('/api/cbam/alerts');
export const cbamAiAnalyze = (question) => api.post('/api/cbam/ai-analyze', { question });
export const getCbamDeclarationPack = (period) => api.get(`/api/cbam/declaration-pack/${period}`);
export const getCbamSupplierCompliance = () => api.get('/api/cbam/supplier-compliance');

// OEE Module endpoints
export const getOeeDashboard = () => api.get('/api/oee/dashboard');
export const getOeeDrilldown = (metricKey) => api.get(`/api/oee/drilldown/${metricKey}`);
export const oeeAiAssist = (payload) => api.post('/api/oee/ai-assist', payload);
export const oeeCustomScenario = (payload) => api.post('/api/oee/custom-scenario', payload);

// Emission Inventory endpoints
export const getEmissionInventory = () => api.get('/api/emissions/inventory');

// Telemetry endpoints
export const trackTelemetry = (payload) => api.post('/api/telemetry/track', payload);
export const getTelemetrySummary = () => api.get('/api/telemetry/summary');

// Auth endpoints (separate to handle token storage)
export const loginApi = (email, password) => api.post('/api/auth/login', { email, password });
export const registerApi = (email, password, name, role) => api.post('/api/auth/register', { email, password, name, role });
export const getMeApi = () => api.get('/api/auth/me');
export const logoutApi = () => api.post('/api/auth/logout');
export const completeTourApi = () => api.post('/api/auth/tour-complete');
export const sessionHeartbeat = (payload) => api.post('/api/auth/heartbeat', payload);
export const getSessionsApi = () => api.get('/api/auth/sessions');
